import {StageSpriteUtils} from "../../../shared/StageSpriteUtils";


export class Message {

  static readonly CONTENT_TYPE_TEXT: number = 0;
  static readonly CONTENT_TYPE_IMAGE: number = 1;
  static readonly CONTENT_TYPE_CONTACT: number = 2;
  static readonly CONTENT_TYPE_LOCATION: number = 3;
  static readonly CONTENT_TYPE_VIDEO: number = 4;

  public timestamp: any;
  public conversationId: string;

  public datePart: string;

  get contentDescription() : string {
    return this.contentType == Message.CONTENT_TYPE_TEXT ? this.content : 'Message sent';
  }

  constructor(public id: string,
              public sender: string,
              public contentType: number,
              public content: string,
              public date: string) {

  }

  static fromAngularFireSnapshots(snapshots: any) : Message[] {
    return snapshots.map(snap => Message.fromSnapshot(snap.key, snap.payload.val()));
  }

  static fromSnapshot(key: string, {sender, conversationId, content, date, timestamp, contentType}) {
    let message =  new Message(key, sender, contentType, content, date);
    message.timestamp = timestamp;
    message.conversationId = conversationId;

    if (date) {
      message.datePart = StageSpriteUtils.formatLongDate(date);
    }

    return message;
  }

}



// WEBPACK FOOTER //
// ./src/providers/communication/models/Message.ts